module.exports = __webpack_public_path__ + "img/2.1.77a0e5e2.png";